import { environment } from '../config/environment';
import { getFromBackendAPI } from './api.service';

export interface CellChangeDto {
  id: number;
  taskId: number;
  taskName: string | null;
  operation:
    | 'set_cell'
    | 'set_range'
    | 'clear_range'
    | 'set_document_hyperlink'
    | 'set_depreciation_rate_hyperlink'
    | 'create_worksheet'
    | 'insert_row'
    | 'insert_column'
    | 'set_formatting'
    | 'set_column_width'
    | 'autofit_columns'
    | 'set_row_height'
    | 'autofit_rows';
  sheetName: string;
  cellAddress: string;
  value: string | null;
  reason: string;
  createdAt: string;
}

export async function getCellChanges(spreadsheetId: string): Promise<CellChangeDto[]> {
  const endpoint = `${environment.api.baseUrl}${environment.api.endpoints.cellChanges}/spreadsheet/${spreadsheetId}`;
  return await getFromBackendAPI<CellChangeDto[]>(endpoint);
}
